import { render, staticRenderFns } from "./KeepAliveRouteWrapper.vue?vue&type=template&id=dabe6726&"
import script from "./KeepAliveRouteWrapper.vue?vue&type=script&lang=js&"
export * from "./KeepAliveRouteWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports